<div class="new-data-explorer-container" [ngClass]="{
  'left-fullscreen': leftPanelFullscreen,
  'right-fullscreen': rightPanelFullscreen
}">
  <!-- Master Panel Component -->
  <app-new-data-explorer-master-panel
    [isFullscreen]="leftPanelFullscreen"
    (toggleFullscreen)="onToggleLeftPanelFullscreen()"
    [style.flex-basis]="leftPanelWidth + '%'"
    [ngClass]="{
      'hidden': rightPanelFullscreen
    }">
  </app-new-data-explorer-master-panel>

  <!-- Resizable Divider -->
  <div class="resizable-divider" 
       *ngIf="!leftPanelFullscreen && !rightPanelFullscreen"
       (mousedown)="startResize($event)">
    <div class="divider-handle">
      <div class="divider-line"></div>
      <div class="divider-grip">
        <i class="material-icons">drag_indicator</i>
      </div>
    </div>
  </div>

  <!-- Details Panel Component -->
  <app-new-data-explorer-details-panel
    [isFullscreen]="rightPanelFullscreen"
    (toggleFullscreen)="onToggleRightPanelFullscreen()"
    [style.flex-basis]="rightPanelWidth + '%'"
    [style.overflow]="'auto'"
    [ngClass]="{
      'hidden': leftPanelFullscreen
    }">
  </app-new-data-explorer-details-panel>
</div>
